<!--
  --
  -- 予約を延長する
  --
  -->
<template>
  <c-container form>
    <c-book-header>予約を延長する</c-book-header>

    <c-book-summary-sheet/>

    <c-book-summary-card/>

    <c-form card-style
      v-model="valid"
      @submit="onSubmit"
      class="mt-6"
    >

      <!-- 入力フォーム -->
      <v-card-text>

        <div v-if="overTime" class="mt-6">
          <span>既に&nbsp;{{overTime}}時間&nbsp;の延長済です。更に延長する場合は下記ご入力ください。</span>
        </div>

        <div class="mt-6">
          <span>ご返却時間を&nbsp;</span>
          <span>
            <select v-model="extensionHour" class="extension_selector">
              <option value="1">1時間</option>
              <option value="2">2時間</option>
              <option value="3">3時間</option>
            </select>
          </span>
          <span>&nbsp;延長する</span>
        </div>

        <div class="mt-6">
          <span class="mt-6">1時間毎に&nbsp;</span><span>{{over}}円</span><span>&nbsp;の延長料金がかかります。</span>
        </div>

        <div v-if="message" class="mt-6">
            <span>{{message}}</span>
        </div>

      </v-card-text>

      <!-- ボタン -->
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="primary"
          :loading="running"
          :disabled="!valid"
          @click="onSubmit"
        >
          延長する
        </v-btn>

      </v-card-actions>

    </c-form>

  </c-container>
</template>

<style>
.extension_selector {
  display: inline-block;
  width: 6rem;
  border: solid 1px#bfbfbf;
}
</style>

<script>
import page from '@/mixins/page'
import CBookHeader from '@/pages/book/components/CBookHeader'
import CBookSummarySheet from '@/pages/book/components/CBookSummarySheet'
import CBookSummaryCard from '@/pages/book/components/CBookSummaryCard'
import CForm from '@/components/CForm'
import * as api from '@/api'
import * as http from '@/libs/http'
import { run } from '@/libs/a'

export default {
  name: 'Cancel',
  mixins: [
    page('予約を延長する')
  ],

  components: {
    CBookHeader,
    CBookSummarySheet,
    CBookSummaryCard,
    CForm
  },

  prepare (to, from, store) {
    // 実行中プログレス
    const running = false

    // disable
    const valid = true

    // メッセージ
    const message = ''

    // 延長時間の初期値
    const extensionHour = 1

    // 車両の1時間延長料金を取得
    const car = store.getters['book/car']
    const over = car.chargeOver

    // 予約が既に延長済の時の「延長料金」を取得
    const charge = store.getters['book/beforeCharge']
    const overCharge = charge.overCharge

    // 予約が既に延長済の時の「延長時間」を取得
    const schedule = store.getters['book/schedule']
    const overTime = schedule.over

    // 既に最大時間
    if (schedule.over >= 12) {
      this.valid = false
      this.message = '延長可能の上限を超えています'
    }

    return {
      running,
      valid,
      message,
      extensionHour,
      over,
      overCharge,
      overTime
    }
  },

  props: {
    running: Boolean,
    valid: Boolean,
    message: String,
    extensionHour: Number,
    over: Number,
    overCharge: Number,
    overTime: Number
  },

  methods: {
    /**
     * サブミット
     */
    onSubmit () {
      run(async () => {
        const rid = this.getters['book/reserveID']
        const uid = this.getters['user/id']
        const reserve = {
          extensionHour: this.extensionHour
        }

        // 処理中
        this.running = true
        this.valid = false

        const resp = await api.putReserveExtension(uid, rid, reserve)
        if (resp.status === http.OK) {
          alert(this.extensionHour + '時間の延長が完了しました')
          this.goTo({ name: 'my/books' })
        }

        if (resp.status === http.Conflict) {
          this.message = '次の予約が入っているため延長できませんでした'
          alert(this.message)
        }

        if (resp.status === http.PaymentRequired) {
          this.message = 'クレジットカード決済エラー'
          alert(this.message)
        }

        if (resp.status === http.BadRequest) {
          this.message = 'エラーが発生しました'
          alert(this.message)
        }

        // 処理中
        this.running = false
      })
    }
  }

}
</script>
